import styled from "styled-components";
import { ConceptColumn } from "../styled";
export const FullConceptColumn = styled(ConceptColumn) `
  width: 100%;
`;
